(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
      $(document).find('.section-header').removeClass('header__overlay'); 
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      if(this.hasAttribute('fixed-nav')){
        $(document).find('.section-header').toggleClass('header__overlay'); 
      }
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("scroll", (event) => {
     var header = document.querySelector('.section-header'),
      scrollTop = window.pageYOffset || document.documentElement.scrollTop,
      headerOffsetTop = header.offsetTop,
      headerOffsetHeight = header.offsetHeight,
      headerPosTop = headerOffsetTop + headerOffsetHeight + 100;
      if (scrollTop > headerPosTop) {
        header.classList.add('scrolled-past-header');
      }else if (scrollTop <= headerPosTop) {
        header.classList.remove('scrolled-past-header');
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", (e) => {
    if (window.matchMedia("(max-width: 989px)").matches) {
      $(document).find('.shop-the__look-products').find('.card--media').addClass('card--horizontal');
    }
  });
  window.addEventListener("resize", function(){
    if (window.matchMedia("(max-width: 989px)").matches) {
      $(document).find('.shop-the__look-products').find('.card--media').addClass('card--horizontal');
    }else{
      $(document).find('.shop-the__look-products').find('.card--media').removeClass('card--horizontal');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgf-stitching-house"] && !Shopify.designMode) return;
  try {
    
function initSGFStitchingHouse(root){
if (!root || root.dataset.sgfV3Ready === 'true') return;
root.dataset.sgfV3Ready = 'true';
const $ = (sel) => root.querySelector(sel);
const $$ = (sel) => [...root.querySelectorAll(sel)];
const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
function visibleElement(selectorOrElement){
if (!selectorOrElement) return null;
if (typeof selectorOrElement !== 'string') return selectorOrElement;
return $$(selectorOrElement).find(el => {
if (!el || el.hidden || el.disabled) return false;
const style = window.getComputedStyle(el);
return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
}) || null;
}
function scrollSafeArea(){
const sticky = $('.sgf-v3__sticky');
const stickyVisible = sticky && window.getComputedStyle(sticky).display !== 'none';
const stickyHeight = stickyVisible ? Math.ceil(sticky.getBoundingClientRect().height) : 0;
return {
top: 18,
bottom: Math.max(120, window.innerHeight - stickyHeight - 18)
};
}
function smartScrollTo(selectorOrElement, options = {}){
const target = visibleElement(selectorOrElement);
if (!target) return;
const delay = Number(options.delay ?? 90);
const align = options.align || options.block || 'nearest';
const topGap = Number(options.topGap ?? 18);
window.setTimeout(() => {
window.requestAnimationFrame(() => {
const rect = target.getBoundingClientRect();
const safe = scrollSafeArea();
let delta = 0;
if (align === 'start'){
delta = rect.top - topGap;
} else if (align === 'center'){
const safeCenter = safe.top + ((safe.bottom - safe.top) / 2);
delta = (rect.top + (rect.height / 2)) - safeCenter;
} else {
const fullyVisible = rect.top >= safe.top && rect.bottom <= safe.bottom;
if (fullyVisible) return;
if (rect.top < safe.top){
delta = rect.top - safe.top;
} else if (rect.bottom > safe.bottom){
delta = rect.bottom - safe.bottom;
if ((rect.top - delta) < safe.top){
delta = rect.top - safe.top;
}
}
}
if (Math.abs(delta) < 4) return;
window.scrollBy({
top: delta,
left: 0,
behavior: prefersReducedMotion ? 'auto' : 'smooth'
});
});
}, delay);
}
function scrollToDecisionProfile(profile, delay = 100){
if (!profile) return;
window.setTimeout(() => {
window.requestAnimationFrame(() => {
const head = profile.querySelector('.sgf-v3__profile-head');
const choices = profile.querySelector('.sgf-v3__profile-fit-choice');
if (!head || !choices){
smartScrollTo(profile, { align:'nearest' });
return;
}
const headRect = head.getBoundingClientRect();
const choicesRect = choices.getBoundingClientRect();
const safe = scrollSafeArea();
const groupTop = headRect.top;
const groupBottom = choicesRect.bottom;
const groupHeight = groupBottom - groupTop;
if (groupTop >= safe.top && groupBottom <= safe.bottom) return;
let delta = 0;
const safeHeight = safe.bottom - safe.top;
if (groupHeight <= safeHeight){
if (groupTop < safe.top){
delta = groupTop - safe.top;
} else if (groupBottom > safe.bottom){
delta = groupBottom - safe.bottom;
if ((groupTop - delta) < safe.top){
delta = groupTop - safe.top;
}
}
} else {
delta = groupTop - safe.top;
}
if (Math.abs(delta) < 4) return;
window.scrollBy({
top: delta,
left: 0,
behavior: prefersReducedMotion ? 'auto' : 'smooth'
});
});
}, delay);
}
function scrollToNextVisible(selector, delay = 100, align = 'nearest'){
const target = visibleElement(selector);
if (target) smartScrollTo(target, { delay, align });
}
const state = {
step: 1,
fabrics: [],
fabric: null,
orderType: null,
forWhom: null,
length: null,
fit: null,
size: null,
babaFit: null,
sonFit: null,
babaSize: null,
sonSize: null,
babaMeasurements: {},
sonMeasurements: {},
measurements: {},
measurementFiles: {
myself: null,
baba: null,
son: null
},
styles: {
collar: null,
sleeve: null,
bottom: null
},
instructions: '',
unusualConfirmedSignature: null,
reviewMomentIndex: -1
};
const headings = {
1: 'Choose Fabric',
2: 'Choose Your Order',
3: 'Fit & Style',
4: 'Review Your Order'
};
const startBtn = $('[data-sgf-start]');
const backBtn = $('[data-sgf-back]');
const nextBtn = $('[data-sgf-next]');
const stickyAction = $('.sgf-v3__sticky');
const heading = $('[data-sgf-heading]');
const stepCount = $('[data-sgf-step-count]');
const message = $('[data-sgf-message]');
const nextLabel = $('[data-next-label]');
const nextInlineEstimate = $('[data-next-estimate]');
const nextInlineKicker = $('[data-next-kicker]');
const nextInlineDetail = $('[data-next-detail]');
const nextInlineTotal = $('[data-next-total]');
const selectionSummary = $('[data-selection-summary]');
const selectionCount = $('[data-selection-count]');
const panels = $$('[data-sgf-panel]');
const progress = $$('.sgf-v3__progress span');
const customOrderOptions = $('[data-custom-order-options]');
const babaDescription = $('[data-baba-description]');
const unstitchedFlow = $('[data-unstitched-flow]');
const myselfFlow = $('[data-myself-flow]');
const mainBabaFlow = $('[data-main-baba-flow]');
const standardSize = $('[data-standard-size]');
const customMeasurements = $('[data-custom-measurements]');
const babaStandard = $('[data-baba-standard]');
const babaCustom = $('[data-baba-custom]');
const sonStandard = $('[data-son-standard]');
const sonCustom = $('[data-son-custom]');
const advancePaymentMyself = $('[data-advance-payment-myself]');
const advancePaymentMainBaba = $('[data-advance-payment-main-baba]');
const sizeChartModal = $('[data-size-chart-modal]');
const kidsSizeChartModal = $('[data-kids-size-chart-modal]');
const guide = $('[data-sgf-guide]');
const guideTitle = $('[data-guide-title]');
const guideCopy = $('[data-guide-copy]');
const guideReopen = $('[data-guide-reopen]');
let guideOpen = false;
let guideTimer = null;
let helpIdleTimer = null;
let helpCycleTimer = null;
let helpCollapseTimer = null;
let attentionTimer = null;
let attentionCleanupTimer = null;
let livePriceFrame = 0;
let lastInlineEstimateSignature = '';
let lastHelpTimerResetAt = 0;
function moneyFromCents(cents){
const value = Number(cents || 0) / 100;
return 'Rs. ' + new Intl.NumberFormat('en-PK', {
maximumFractionDigits: 0
}).format(value);
}
const SAVED_FITS_KEY = 'sgf_stitching_saved_fits_v1';
function readSavedFits(){
try{
const saved = JSON.parse(window.localStorage.getItem(SAVED_FITS_KEY) || '{}') || {};
const now = Date.now();
const maxAge = {
myself: 180 * 24 * 60 * 60 * 1000,
baba: 180 * 24 * 60 * 60 * 1000,
son: 90 * 24 * 60 * 60 * 1000
};
let changed = false;
Object.keys(saved).forEach(type => {
const profile = saved[type];
if (!profile || !profile.savedAt) return;
const ttl = maxAge[type] || maxAge.myself;
if (now - Number(profile.savedAt) > ttl){
delete saved[type];
changed = true;
}
});
if (changed) window.localStorage.setItem(SAVED_FITS_KEY, JSON.stringify(saved));
return saved;
}catch(e){
return {};
}
}
function writeSavedFits(data){
try{
window.localStorage.setItem(SAVED_FITS_KEY, JSON.stringify(data));
return true;
}catch(e){
return false;
}
}
function measurementConfig(type){
if (type === 'baba'){
return { stateKey:'babaMeasurements', selector:'[data-baba-measure]', dataKey:'babaMeasure', label:'Baba' };
}
if (type === 'son'){
return { stateKey:'sonMeasurements', selector:'[data-son-measure]', dataKey:'sonMeasure', label:'Son' };
}
return { stateKey:'measurements', selector:'[data-measure]', dataKey:'measure', label:'Your' };
}
const measurementPreviewUrls = {
myself: null,
baba: null,
son: null
};
function measurementFile(type){
return state.measurementFiles?.[type] || null;
}
function hasMeasurementFile(type){
return Boolean(measurementFile(type));
}
function updateMeasurementUploadUI(type){
const file = measurementFile(type);
const block = $(`[data-upload-block="${type}"]`);
const preview = $(`[data-upload-preview="${type}"]`);
const thumb = $(`[data-upload-thumb="${type}"]`);
const name = $(`[data-upload-name="${type}"]`);
const label = $(`[data-upload-label="${type}"]`);
block?.classList.toggle('has-file', Boolean(file));
preview?.classList.toggle('is-visible', Boolean(file));
if (!file){
if (label) label.textContent = 'Upload photo';
if (thumb) thumb.style.backgroundImage = '';
if (name) name.textContent = 'Attached';
return;
}
if (label) label.textContent = 'Replace photo';
if (name) name.textContent = file.name || 'Tailor slip / size chart';
if (measurementPreviewUrls[type]){
URL.revokeObjectURL(measurementPreviewUrls[type]);
}
measurementPreviewUrls[type] = URL.createObjectURL(file);
if (thumb){
thumb.style.backgroundImage = `url("${measurementPreviewUrls[type]}")`;
thumb.style.backgroundSize = 'cover';
thumb.style.backgroundPosition = 'center';
}
}
function clearMeasurementFile(type, clearInput = true){
if (measurementPreviewUrls[type]){
URL.revokeObjectURL(measurementPreviewUrls[type]);
measurementPreviewUrls[type] = null;
}
state.measurementFiles[type] = null;
if (clearInput){
const input = $(`[data-measure-file="${type}"]`);
if (input) input.value = '';
}
updateMeasurementUploadUI(type);
interactionHappened();
}
async function loadImageForCompression(file){
if ('createImageBitmap' in window){
try{return await createImageBitmap(file);}catch(e){}
}
return await new Promise((resolve,reject) => {
const url = URL.createObjectURL(file);
const img = new Image();
img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('Image could not be read.')); };
img.src = url;
});
}
async function compressMeasurementImage(file){
if (file.size <= 1600 * 1024) return file;
const image = await loadImageForCompression(file);
const sourceWidth = image.width || image.naturalWidth;
const sourceHeight = image.height || image.naturalHeight;
if (!sourceWidth || !sourceHeight) return file;
const maxSide = 1600;
const scale = Math.min(1, maxSide / Math.max(sourceWidth, sourceHeight));
const width = Math.max(1, Math.round(sourceWidth * scale));
const height = Math.max(1, Math.round(sourceHeight * scale));
const canvas = document.createElement('canvas');
canvas.width = width; canvas.height = height;
const ctx = canvas.getContext('2d', { alpha:false });
ctx.fillStyle = '#fff'; ctx.fillRect(0,0,width,height); ctx.drawImage(image,0,0,width,height);
if (typeof image.close === 'function') image.close();
const toBlob = quality => new Promise(resolve => canvas.toBlob(resolve,'image/jpeg',quality));
let blob = await toBlob(.84);
if (blob && blob.size > 2200 * 1024) blob = await toBlob(.72);
if (!blob) return file;
const baseName = (file.name || 'measurement-slip').replace(/\.[^.]+$/,'').replace(/[^a-zA-Z0-9._-]+/g,'-').slice(0,80);
return new File([blob], `${baseName || 'measurement-slip'}.jpg`, { type:'image/jpeg', lastModified:Date.now() });
}
async function acceptMeasurementFile(type, file){
if (!file) return false;
if (!String(file.type || '').startsWith('image/')){
showMessage('Please upload an image of the tailor slip or size chart.');
return false;
}
if (file.size > 12 * 1024 * 1024){
showMessage('Please use an image smaller than 12 MB.');
return false;
}
const label = $(`[data-upload-label="${type}"]`);
const previousLabel = label?.textContent || 'Upload photo';
if (label) label.textContent = 'Optimizing image…';
try{
const optimized = await compressMeasurementImage(file);
state.measurementFiles[type] = optimized;
updateMeasurementUploadUI(type);
interactionHappened();
return true;
}catch(error){
console.warn('SGF image optimization skipped:', error);
if (file.size > 4 * 1024 * 1024){
showMessage('This image is too large to optimize in your browser. Please choose a smaller photo.');
if (label) label.textContent = previousLabel;
return false;
}
state.measurementFiles[type] = file;
updateMeasurementUploadUI(type);
interactionHappened();
return true;
}
}
function savedFitExists(type){
const saved = readSavedFits();
return Boolean(saved[type] && saved[type].measurements);
}
const savedProfileActive = { myself:false, baba:false, son:false };
const savedStatusTimers = { myself:null, baba:null, son:null };
function savedProfileLabel(type){
if (type === 'myself') return 'Your';
if (type === 'baba') return 'Baba';
return 'Son';
}
function placeSavedProfile(type, hasSaved = savedFitExists(type)){
const card = $(`[data-saved-profile="${type}"]`);
const flowSelector = type === 'myself' ? '[data-custom-measurements]' : type === 'baba' ? '[data-baba-custom]' : '[data-son-custom]';
const flow = $(flowSelector);
if (!card || !flow) return;
card.classList.toggle('is-priority-saved', hasSaved);
if (hasSaved){
if (flow.firstElementChild !== card) flow.insertBefore(card, flow.firstElementChild);
} else if (flow.lastElementChild !== card){
flow.appendChild(card);
}
}
function setProfileStatus(type, text = ''){
const status = $(`[data-profile-status="${type}"]`);
if (!status) return;
clearTimeout(savedStatusTimers[type]);
status.textContent = text;
status.hidden = !text;
if (text){
savedStatusTimers[type] = window.setTimeout(() => {
status.hidden = true;
status.textContent = '';
}, 1800);
}
}
function revealPersonalFit(type, container){
if (!container) return;
const savedCard = $(`[data-saved-profile="${type}"]`);
if (savedFitExists(type) && savedCard && container.contains(savedCard)){
smartScrollTo(savedCard, { delay:90, align:'nearest' });
} else {
smartScrollTo(container, { delay:90, align:'nearest' });
}
}
function refreshSavedFitUI(type, messageText = ''){
const hasSaved = savedFitExists(type);
const active = Boolean(savedProfileActive[type]);
const card = $(`[data-saved-profile="${type}"]`);
const title = $(`[data-saved-title="${type}"]`);
const copy = $(`[data-saved-copy="${type}"]`);
const load = $(`[data-load-profile="${type}"]`);
const save = $(`[data-save-profile="${type}"]`);
const manage = $(`[data-saved-manage="${type}"]`);
placeSavedProfile(type, hasSaved);
card?.classList.toggle('is-saved', hasSaved);
card?.classList.toggle('is-active-saved', hasSaved && active);
if (title){
title.textContent = hasSaved ? 'Saved measurements' : 'Save measurements';
}
if (copy){
copy.hidden = hasSaved;
copy.textContent = 'Keep them on this device for next time.';
}
if (load){
load.hidden = !hasSaved;
load.disabled = hasSaved && active;
load.textContent = active ? 'Using saved' : 'Use saved';
load.setAttribute('aria-pressed', active ? 'true' : 'false');
}
if (save){
save.hidden = hasSaved;
save.textContent = 'Save';
}
if (manage){
manage.hidden = !hasSaved;
if (!hasSaved) manage.open = false;
}
if (messageText) setProfileStatus(type, messageText);
}
function markSavedProfileEditable(type){
if (!savedFitExists(type)) return;
}
function saveMeasurementsProfile(type){
const config = measurementConfig(type);
const store = state[config.stateKey] || {};
const required = ['Chest','Shoulder','Sleeve','Collar','Kameez Length','Bottom Length'];
const missing = required.find(key => !store[key]);
if (missing){
if (hasMeasurementFile(type)){
setProfileStatus(type, 'Enter measurements to save this fit.');
return;
}
showMessage(`Please enter ${config.label === 'Your' ? '' : config.label + "'s "}${missing} before saving.`.replace('enter  ', 'enter '));
return;
}
const saved = readSavedFits();
saved[type] = { measurements: { ...store }, savedAt: Date.now() };
if (!writeSavedFits(saved)){
showMessage('Your browser did not allow saving measurements on this device.');
return;
}
savedProfileActive[type] = true;
refreshSavedFitUI(type, 'Saved');
}
function advanceAfterSavedMeasurements(type){
if (type === 'baba'){
scrollToDecisionProfile($('[data-son-profile]'), 120);
return;
}
if (type === 'son'){
smartScrollTo($('[data-main-baba-tailoring]'), { delay:120, align:'start', topGap:18 });
return;
}
smartScrollTo($('[data-myself-tailoring]'), { delay:120, align:'start', topGap:18 });
}
function loadMeasurementsProfile(type){
const saved = readSavedFits();
const profile = saved[type];
if (!profile?.measurements) return;
const config = measurementConfig(type);
state[config.stateKey] = { ...profile.measurements };
$$(config.selector).forEach(input => {
const key = input.dataset[config.dataKey];
if (key && typeof profile.measurements[key] !== 'undefined') input.value = profile.measurements[key];
});
savedProfileActive[type] = true;
refreshSavedFitUI(type, 'Applied');
interactionHappened();
advanceAfterSavedMeasurements(type);
}
function clearMeasurementsProfile(type){
const saved = readSavedFits();
delete saved[type];
writeSavedFits(saved);
savedProfileActive[type] = false;
refreshSavedFitUI(type, 'Saved measurements removed');
}
function showGuide(title, copy, delay = 0){
if (!guideOpen || !guide) return;
clearTimeout(guideTimer);
guideTimer = setTimeout(() => {
if (!guideOpen) return;
if (guideTitle) guideTitle.textContent = title;
if (guideCopy) guideCopy.textContent = copy;
guide.classList.add('is-visible');
guideReopen?.classList.add('is-hidden');
}, delay);
}
function hideGuide(){
clearTimeout(guideTimer);
guide?.classList.remove('is-visible');
guideReopen?.classList.remove('is-hidden');
}
function closeGuide(){
guideOpen = false;
hideGuide();
clearTimeout(helpCollapseTimer);
helpCollapseTimer = setTimeout(collapseHelpPill, 700);
scheduleHelpWiggle(7600);
scheduleHelpCycle(15000);
}
function collapseHelpPill(){
if (!guideReopen || guideOpen) return;
guideReopen.classList.add('is-collapsed');
}
function expandHelpPill(duration = 2700){
if (!guideReopen || guideOpen) return;
clearTimeout(helpCollapseTimer);
guideReopen.classList.remove('is-collapsed');
helpCollapseTimer = setTimeout(() => {
collapseHelpPill();
}, duration);
}
function scheduleHelpWiggle(delay = 7600){
clearTimeout(helpIdleTimer);
helpIdleTimer = setTimeout(() => {
if (guideOpen || !guideReopen) return;
collapseHelpPill();
guideReopen.classList.remove('sgf-help-wiggle');
window.requestAnimationFrame(() => {
window.requestAnimationFrame(() => guideReopen.classList.add('sgf-help-wiggle'));
});
window.setTimeout(() => {
guideReopen.classList.remove('sgf-help-wiggle');
}, 1000);
}, delay);
}
function scheduleHelpCycle(delay = 16500){
clearTimeout(helpCycleTimer);
helpCycleTimer = setTimeout(() => {
if (guideOpen || !guideReopen) return;
expandHelpPill(2800);
}, delay);
}
function startHelpPillSequence(){
if (!guideReopen) return;
guideReopen.classList.remove('is-collapsed');
clearTimeout(helpCollapseTimer);
helpCollapseTimer = setTimeout(collapseHelpPill, 3200);
scheduleHelpWiggle(7600);
scheduleHelpCycle(15000);
}
function guideForCurrentStep(delay = 0){
if (!guideOpen) return;
if (!root.classList.contains('is-building')){
showGuide(
'Start your SGF order',
'Tap Start Your Order, then choose the fabric you want us to prepare.',
delay
);
return;
}
if (state.step === 1){
if (!state.fabrics.length){
showGuide(
'Choose your fabric',
'Select one or more available fabrics or colours. Each selected fabric can become its own outfit.',
delay
);
} else {
showGuide(
'Fabric selection ready',
'Your selected fabrics are ready. Add more if you like, or continue to choose the order type.',
delay
);
}
return;
}
if (state.step === 2){
if (!state.orderType){
showGuide(
'Choose your order type',
'Choose Unstitched Only or SGF Signature Stitching.',
delay
);
} else if (state.orderType === 'custom' && !state.forWhom){
showGuide(
'Who are we stitching for?',
'For Myself is a single outfit. Main Aur Baba creates a coordinated father-and-son set and is the stronger value when you want matching outfits.',
delay
);
const babaCard = $('[data-for="main-baba"]');
if (babaCard){
babaCard.classList.remove('sgf-main-baba-highlight');
window.requestAnimationFrame(() => window.requestAnimationFrame(() => babaCard.classList.add('sgf-main-baba-highlight')));
window.setTimeout(() => babaCard.classList.remove('sgf-main-baba-highlight'), 1500);
}
} else {
showGuide(
'Ready for fit & style',
state.forWhom === 'main-baba'
? 'Next, set Baba and Son fits separately, then choose the matching style.'
: 'Next, choose your fit and Shalwar Kameez finishing details.',
delay
);
}
return;
}
if (state.step === 3){
if (state.forWhom === 'main-baba'){
const fabricRuleCopy = state.sonFit === 'custom'
? 'Son Personal Measurements uses two complete 4-meter cuts: one for Baba and one for Son.'
: state.sonFit === 'standard'
? 'Son Standard / Age Size uses the shared 6-meter Main Aur Baba fabric rule.'
: 'Choose Baba and Son fit methods. Son Standard / Age Size uses 6 meters; Son Personal Measurements uses two full 4-meter cuts.';
showGuide('Fit Baba and Son separately', fabricRuleCopy, delay);
} else {
showGuide(
'Set your fit & style',
'Choose Standard Size or Personal Measurements, then select collar, sleeve and bottom style.',
delay
);
}
return;
}
if (state.step === 4){
showGuide(
'Review and checkout',
'Check the fabric, fit, measurements and price once. When everything looks right, proceed to checkout.',
delay
);
}
}
$('[data-guide-dismiss]')?.addEventListener('click', closeGuide);
guideReopen?.addEventListener('click', () => {
clearTimeout(helpIdleTimer);
clearTimeout(helpCycleTimer);
clearTimeout(helpCollapseTimer);
guideOpen = true;
guideReopen.classList.remove('sgf-help-wiggle');
guideForCurrentStep(0);
});
function showMessage(text){
message.textContent = text;
message.classList.add('is-visible');
clearTimeout(message._timer);
message._timer = setTimeout(() => {
message.classList.remove('is-visible');
}, 4200);
}
function premiumAttention(element){
if (!element || element.disabled) return;
element.classList.remove('sgf-attention');
window.requestAnimationFrame(() => {
window.requestAnimationFrame(() => element.classList.add('sgf-attention'));
});
clearTimeout(attentionCleanupTimer);
attentionCleanupTimer = setTimeout(() => {
element.classList.remove('sgf-attention');
}, 1450);
}
function guideTarget(selector){
const candidates = $$(selector);
const target = candidates.find(el => {
if (el.disabled) return false;
const style = window.getComputedStyle(el);
return style.display !== 'none' && style.visibility !== 'hidden' && el.offsetParent !== null;
});
if (!target) return;
target.classList.remove('sgf-guide-target');
window.requestAnimationFrame(() => {
window.requestAnimationFrame(() => target.classList.add('sgf-guide-target'));
});
window.setTimeout(() => {
target.classList.remove('sgf-guide-target');
}, 1500);
}
function clearAttentionTimer(){
if (attentionTimer){
clearTimeout(attentionTimer);
attentionTimer = null;
}
}
function scheduleAttention(delay = 4600){
clearAttentionTimer();
attentionTimer = setTimeout(() => {
if (!root.classList.contains('is-building')){
premiumAttention(startBtn);
scheduleAttention(6800);
return;
}
if (state.step === 1){
if (!state.fabrics.length){
guideTarget('[data-sgf-fabric]');
} else {
premiumAttention(nextBtn);
}
} else if (state.step === 2){
if (!state.orderType){
guideTarget('[data-order-type]');
} else if (state.orderType === 'custom' && !state.forWhom){
guideTarget('[data-for]');
} else {
premiumAttention(nextBtn);
}
} else if (state.step === 3){
if (state.orderType === 'unstitched' && !state.length){
guideTarget('[data-length]');
} else if (state.orderType === 'custom' && state.forWhom === 'myself' && !state.fit){
guideTarget('[data-fit]');
} else if (state.orderType === 'custom' && state.forWhom === 'myself' && state.fit === 'standard' && !state.size){
guideTarget('[data-size]');
} else if (state.orderType === 'custom' && state.forWhom === 'main-baba' && !state.babaFit){
guideTarget('[data-baba-fit]');
} else if (state.orderType === 'custom' && state.forWhom === 'main-baba' && state.babaFit === 'standard' && !state.babaSize){
guideTarget('[data-baba-size]');
} else if (state.orderType === 'custom' && state.forWhom === 'main-baba' && !state.sonFit){
guideTarget('[data-son-fit]');
} else if (state.orderType === 'custom' && state.forWhom === 'main-baba' && state.sonFit === 'standard' && !state.sonSize){
guideTarget('[data-son-size]');
} else {
premiumAttention(nextBtn);
}
} else if (state.step === 4){
premiumAttention(nextBtn);
}
}, delay);
}
function scheduleLivePriceUpdate(){
if (livePriceFrame) return;
livePriceFrame = window.requestAnimationFrame(() => {
livePriceFrame = 0;
updateLivePrice();
});
}
function interactionHappened(){
message.classList.remove('is-visible');
scheduleAttention();
scheduleLivePriceUpdate();
const now = window.performance?.now ? window.performance.now() : Date.now();
if (!guideOpen && (now - lastHelpTimerResetAt > 650)){
lastHelpTimerResetAt = now;
scheduleHelpWiggle(7600);
scheduleHelpCycle(15000);
}
if (guideOpen){
guideForCurrentStep(110);
}
}
function selectOne(selector, active){
$$(selector).forEach(el => {
el.classList.remove('is-selected');
if (el.matches('button,[role="button"]')) el.setAttribute('aria-pressed','false');
});
active.classList.add('is-selected');
if (active.matches('button,[role="button"]')) active.setAttribute('aria-pressed','true');
}
function setNextButtonText(textValue){
if (nextLabel){
nextLabel.textContent = textValue;
return;
}
if (nextBtn){
nextBtn.textContent = textValue;
}
}
function getNextButtonText(){
if (nextLabel) return nextLabel.textContent || '';
return nextBtn ? (nextBtn.textContent || '') : '';
}
function updateInlineEstimate(estimate){
if (!nextInlineEstimate || !nextBtn) return;
if (state.step === 4 || !estimate || !estimate.total){
lastInlineEstimateSignature = '';
nextInlineEstimate.hidden = true;
stickyAction?.classList.remove('has-inline-estimate');
return;
}
const totalText = `${estimate.prefix}${moneyFromCents(estimate.total)}`;
const signature = `${estimate.kicker}|${estimate.detail}|${totalText}`;
const changed = signature !== lastInlineEstimateSignature;
if (nextInlineKicker && nextInlineKicker.textContent !== estimate.kicker) nextInlineKicker.textContent = estimate.kicker;
if (nextInlineDetail && nextInlineDetail.textContent !== estimate.detail) nextInlineDetail.textContent = estimate.detail;
if (nextInlineTotal && nextInlineTotal.textContent !== totalText) nextInlineTotal.textContent = totalText;
nextInlineEstimate.hidden = false;
stickyAction?.classList.add('has-inline-estimate');
if (changed){
lastInlineEstimateSignature = signature;
nextInlineEstimate.classList.remove('is-updated');
window.requestAnimationFrame(() => {
window.requestAnimationFrame(() => {
nextInlineEstimate.classList.add('is-updated');
window.setTimeout(() => nextInlineEstimate.classList.remove('is-updated'), 240);
});
});
}
}
function setStep(step){
state.step = Math.max(1, Math.min(4, step));
root.classList.toggle('is-reviewing', state.step === 4);
panels.forEach(panel => {
panel.classList.toggle('is-active', Number(panel.dataset.sgfPanel) === state.step);
});
progress.forEach((bar, index) => {
bar.classList.toggle('is-active', index < state.step);
});
heading.textContent = headings[state.step];
stepCount.textContent = `Step ${state.step} of 4`;
if (state.step === 1) setNextButtonText('Continue');
if (state.step === 2) setNextButtonText('Continue');
if (state.step === 3) setNextButtonText('Review');
if (state.step === 4) setNextButtonText('Checkout');
if (state.step === 3) renderStep3();
if (state.step === 4) renderReview();
message.classList.remove('is-visible');
smartScrollTo($('.sgf-v3__topbar') || root, { delay:70, align:'start', topGap:10 });
updateLivePrice();
scheduleAttention(4300);
if (guideOpen) guideForCurrentStep(120);
if (!guideOpen){
scheduleHelpWiggle(7600);
scheduleHelpCycle(15000);
}
}
function selectedFabrics(){
return Array.isArray(state.fabrics) ? state.fabrics : [];
}
function syncPrimaryFabric(){
state.fabric = selectedFabrics()[0] || null;
}
function fabricKey(fabric){
return `${fabric?.productId || ''}:${fabric?.color || ''}:${fabric?.fourMeterVariantId || ''}`;
}
function variantForFabric(fabric, choice){
if (!fabric) return null;
const target = String(choice || '').toLowerCase();
if (target.includes('4')){
if (!fabric.fourMeterVariantId) return null;
return {
id: Number(fabric.fourMeterVariantId),
title: '4 Meters',
price: Number(fabric.fourMeterPrice || 0),
available: Boolean(fabric.fourMeterAvailable),
image: fabric.fourMeterImage || fabric.image || ''
};
}
if (target.includes('5')){
if (!fabric.fiveMeterVariantId) return null;
return {
id: Number(fabric.fiveMeterVariantId),
title: '5 Meters',
price: Number(fabric.fiveMeterPrice || 0),
available: Boolean(fabric.fiveMeterAvailable),
image: fabric.image || ''
};
}
if (target.includes('6')){
if (!fabric.sixMeterVariantId) return null;
return {
id: Number(fabric.sixMeterVariantId),
title: '6 Meters',
price: Number(fabric.sixMeterPrice || 0),
available: Boolean(fabric.sixMeterAvailable),
image: fabric.sixMeterImage || fabric.image || ''
};
}
return null;
}
function variantForChoice(choice){
return variantForFabric(state.fabric, choice);
}
function allSelectedHaveChoice(choice){
const fabrics = selectedFabrics();
if (!fabrics.length) return false;
return fabrics.every(fabric => {
const variant = variantForFabric(fabric, choice);
return Boolean(variant && variant.id && variant.available !== false);
});
}
function totalFabricPriceForChoice(choice, quantity = 1){
return selectedFabrics().reduce((sum, fabric) => {
const variant = variantForFabric(fabric, choice);
if (!variant || !variant.id || variant.available === false) return sum;
return sum + (Number(variant.price || 0) * quantity);
}, 0);
}
function mainBabaUsesTwoAdultCuts(){
return (
state.orderType === 'custom' &&
state.forWhom === 'main-baba' &&
state.sonFit === 'custom'
);
}
function currentFabricChoice(){
if (state.orderType === 'unstitched' && state.length) return state.length;
if (state.orderType === 'custom' && state.forWhom === 'main-baba'){
return mainBabaUsesTwoAdultCuts() ? '4 Meters' : '6 Meters';
}
if (state.orderType === 'custom' && state.forWhom === 'myself') return '4 Meters';
return '4 Meters';
}
function currentFabricVariant(){
return variantForFabric(state.fabric, currentFabricChoice());
}
function currentFabricQuantity(){
return mainBabaUsesTwoAdultCuts() ? 2 : 1;
}
function currentFabricPrice(){
const choice = currentFabricChoice();
return totalFabricPriceForChoice(choice, currentFabricQuantity());
}
function stitchingUnitPrice(){
return Math.max(0, Number(root.dataset.stitchingServicePrice || 0));
}
function stitchingCount(){
const fabricCount = selectedFabrics().length;
if (state.orderType !== 'custom') return 0;
return fabricCount * (state.forWhom === 'main-baba' ? 2 : 1);
}
function stitchingTotalPrice(){
if (state.orderType !== 'custom') return 0;
return stitchingUnitPrice() * stitchingCount();
}
function liveEstimate(){
const fabrics = selectedFabrics();
const count = fabrics.length;
if (!count) return null;
const sum4 = totalFabricPriceForChoice('4 Meters', 1);
const sum5 = totalFabricPriceForChoice('5 Meters', 1);
const sum6 = totalFabricPriceForChoice('6 Meters', 1);
let fabric = sum4;
let stitching = 0;
let prefix = 'From ';
let detail = `${count} fabric${count === 1 ? '' : 's'}`;
let kicker = 'Live estimate';
if (state.orderType === 'unstitched'){
if (state.length){
if (String(state.length).startsWith('4')) fabric = sum4;
if (String(state.length).startsWith('5')) fabric = sum5;
if (String(state.length).startsWith('6')) fabric = sum6;
prefix = '';
detail = `${count} fabric${count === 1 ? '' : 's'} · ${String(state.length).replace(' Meters','M')} each`;
} else {
detail = `${count} fabric${count === 1 ? '' : 's'} · length pending`;
}
}
if (state.orderType === 'custom'){
stitching = stitchingTotalPrice();
if (!state.forWhom){
fabric = sum4;
detail = `${count} fabric${count === 1 ? '' : 's'} · fit pending`;
} else if (state.forWhom === 'myself'){
fabric = sum4;
prefix = '';
detail = `${count} outfit${count === 1 ? '' : 's'} · stitching included`;
} else if (state.forWhom === 'main-baba'){
if (state.sonFit === 'custom'){
fabric = sum4 * 2;
prefix = '';
detail = `${count} set${count === 1 ? '' : 's'} · 4M × 2`;
} else if (state.sonFit === 'standard'){
fabric = sum6;
prefix = '';
detail = `${count} set${count === 1 ? '' : 's'} · 6M each`;
} else {
const candidate6 = allSelectedHaveChoice('6 Meters') ? sum6 : 0;
const candidate4x2 = sum4 * 2;
const candidates = [candidate6, candidate4x2].filter(Boolean);
fabric = candidates.length ? Math.min(...candidates) : sum4;
prefix = 'From ';
detail = `${count} set${count === 1 ? '' : 's'} · Son fit pending`;
}
}
}
return {
total: fabric + stitching,
detail,
prefix,
kicker
};
}
function updateLivePrice(){
if (state.step === 4){ updateInlineEstimate(null); return; }
const estimate = liveEstimate();
if (!estimate || !estimate.total){ updateInlineEstimate(null); return; }
updateInlineEstimate(estimate);
}
function updateAdvancePaymentNotice(){
const myselfNeedsAdvance = (
state.orderType === 'custom' &&
state.forWhom === 'myself' &&
state.fit === 'custom'
);
const mainBabaNeedsAdvance = (
state.orderType === 'custom' &&
state.forWhom === 'main-baba' &&
(state.babaFit === 'custom' || state.sonFit === 'custom')
);
advancePaymentMyself?.classList.toggle('is-visible', myselfNeedsAdvance);
advancePaymentMainBaba?.classList.toggle('is-visible', mainBabaNeedsAdvance);
}
function renderStep3(){
updateAdvancePaymentNotice();
[unstitchedFlow, myselfFlow, mainBabaFlow].forEach(el => el?.classList.remove('is-visible'));
if (selectedFabrics().length){
$$('[data-length]').forEach(btn => {
const label = String(btn.dataset.length || '');
btn.hidden = !allSelectedHaveChoice(label);
});
}
if (state.orderType === 'unstitched'){
unstitchedFlow?.classList.add('is-visible');
return;
}
if (state.forWhom === 'main-baba'){
mainBabaFlow?.classList.add('is-visible');
babaStandard?.classList.toggle('is-visible', state.babaFit === 'standard');
babaCustom?.classList.toggle('is-visible', state.babaFit === 'custom');
sonStandard?.classList.toggle('is-visible', state.sonFit === 'standard');
sonCustom?.classList.toggle('is-visible', state.sonFit === 'custom');
$$('[data-baba-fit]').forEach(btn => {
btn.classList.toggle('is-selected', btn.dataset.babaFit === state.babaFit);
});
$$('[data-son-fit]').forEach(btn => {
btn.classList.toggle('is-selected', btn.dataset.sonFit === state.sonFit);
});
return;
}
myselfFlow?.classList.add('is-visible');
standardSize?.classList.toggle('is-visible', state.fit === 'standard');
customMeasurements?.classList.toggle('is-visible', state.fit === 'custom');
}
function clearValidationError(el){
if (!el) return;
el.classList.remove('sgf-validation-error');
el.removeAttribute?.('aria-invalid');
const field = el.closest?.('.sgf-v3__field,.sgf-v3__style-group,.sgf-v3__size-row,.sgf-v3__fit-grid,.sgf-v3__profile-fit-choice,.sgf-v3__age-grid');
field?.classList.remove('sgf-validation-error');
}
function validationTarget(target, focusTarget = null){
if (!target) return false;
$$('.sgf-validation-error').forEach(el => {
  el.classList.remove('sgf-validation-error');
  el.removeAttribute?.('aria-invalid');
});
const visual = target.matches?.('input,select,textarea') ? (target.closest('.sgf-v3__field') || target) : target;
visual.classList.add('sgf-validation-error');
if (target.matches?.('input,select,textarea')) target.setAttribute('aria-invalid','true');
window.requestAnimationFrame(() => {
  visual.scrollIntoView({behavior:'smooth',block:'center',inline:'nearest'});
  const focusEl = focusTarget || (target.matches?.('input,select,textarea,button') ? target : target.querySelector?.('input,select,textarea,button'));
  if (focusEl) window.setTimeout(() => focusEl.focus({preventScroll:true}), 420);
});
return false;
}
function validationGroup(selector){
const first = $$(selector).find(el => el.offsetParent !== null && !el.disabled);
if (!first) return false;
const group = first.closest('.sgf-v3__style-group,.sgf-v3__size-row,.sgf-v3__fit-grid,.sgf-v3__profile-fit-choice,.sgf-v3__age-grid') || first;
return validationTarget(group, first);
}
function measurementInput(type,key){
const selector = type === 'baba' ? '[data-baba-measure]' : type === 'son' ? '[data-son-measure]' : '[data-measure]';
return $$(selector).find(el => {
  const value = type === 'baba' ? el.dataset.babaMeasure : type === 'son' ? el.dataset.sonMeasure : el.dataset.measure;
  return value === key;
});
}
function validateMeasurements(){
if (hasMeasurementFile('myself')) return true;
const required = ['Chest','Shoulder','Sleeve','Collar','Kameez Length','Bottom Length'];
const missing = required.find(key => !state.measurements[key]);
if (missing){
showMessage(`Please enter ${missing}.`);
return validationTarget(measurementInput('myself', missing));
}
const unusual = [];
$$('[data-measure]').forEach(input => {
const raw = input.value.trim();
if (!raw) return;
const value = Number(raw);
const min = input.min ? Number(input.min) : null;
const max = input.max ? Number(input.max) : null;
if ((min !== null && value < min) || (max !== null && value > max)){
unusual.push(`${input.dataset.label || input.dataset.measure}: ${value}`);
}
});
if (unusual.length){
const signature = unusual.join('|');
if (state.unusualConfirmedSignature !== signature){
state.unusualConfirmedSignature = signature;
showMessage(`Please check this measurement: ${unusual[0]}. If it is intentional, press Next again to confirm.`);
const label = unusual[0].split(':')[0];
const unusualInput = $$('[data-measure]').find(el => (el.dataset.label || el.dataset.measure) === label);
return validationTarget(unusualInput);
}
}
return true;
}
function validateProfileMeasurements(type){
if (hasMeasurementFile(type)) return true;
const store = type === 'baba' ? state.babaMeasurements : state.sonMeasurements;
const label = type === 'baba' ? 'Baba' : 'Son';
const required = ['Chest','Shoulder','Sleeve','Collar','Kameez Length','Bottom Length'];
const missing = required.find(key => !store[key]);
if (missing){
showMessage(`Please enter ${label}'s ${missing}.`);
return validationTarget(measurementInput(type, missing));
}
return true;
}
function validateStyle(){
if (!state.styles.collar){
showMessage('Please choose a neck style.');
return validationGroup('[data-style-group="collar"]');
}
if (!state.styles.sleeve){
showMessage('Please choose Round or Cuff.');
return validationGroup('[data-style-group="sleeve"]');
}
if (!state.styles.bottom){
showMessage('Please choose Shalwar or Trouser.');
return validationGroup('[data-style-group="bottom"]');
}
return true;
}
function validateStep3(){
if (state.orderType === 'unstitched'){
if (!state.length){
showMessage('Please select 4 M, 5 M or 6 M.');
return validationGroup('[data-length]');
}
return true;
}
if (state.forWhom === 'main-baba'){
if (!state.babaFit){
showMessage("Please choose Baba's fit method.");
return validationGroup('[data-baba-fit]');
}
if (state.babaFit === 'standard' && !state.babaSize){
showMessage("Please select Baba's standard size.");
return validationGroup('[data-baba-size]');
}
if (state.babaFit === 'custom' && !validateProfileMeasurements('baba')){
return false;
}
if (!state.sonFit){
showMessage("Please choose the son's fit method.");
return validationGroup('[data-son-fit]');
}
if (state.sonFit === 'standard' && !state.sonSize){
showMessage("Please select the son's age size.");
return validationGroup('[data-son-size]');
}
if (state.sonFit === 'custom' && !validateProfileMeasurements('son')){
return false;
}
if (state.sonFit === 'standard' && !allSelectedHaveChoice('6 Meters')){
showMessage('Every selected fabric needs an available 6 Meter variant for a standard-age Main Aur Baba set.');
return false;
}
if (state.sonFit === 'custom' && !allSelectedHaveChoice('4 Meters')){
showMessage('Every selected fabric needs an available 4 Meter variant when Son Personal Measurements are selected.');
return false;
}
return validateStyle();
}
if (!state.fit){
showMessage('Please choose Standard Size or Personal Fit.');
return validationGroup('[data-fit]');
}
if (state.fit === 'standard' && !state.size){
showMessage('Please select your standard size.');
return validationGroup('[data-size]');
}
if (state.fit === 'custom' && !validateMeasurements()){
return false;
}
return validateStyle();
}
function renderReview(){
const fabrics = selectedFabrics();
if (!fabrics.length) return;
const count = fabrics.length;
const awardTitle = $('[data-review-award-title]');
const awardNote = $('[data-review-award-note]');
const rewardMoments = state.orderType === 'custom' && state.forWhom === 'main-baba'
? [
{ title:'Made for the Two of You', note:'Two individual fits. One beautifully coordinated order.' },
{ title:'A Tradition Worth Wearing', note:'Baba + Son, brought together in one considered look.' },
{ title:'Two Fits. One Story.', note:'Your coordinated set is ready for its next chapter.' },
{ title:'Made to Be Remembered', note:'Your fabric and finishing choices came together beautifully.' },
{ title:'Your Legacy Set Is Ready', note:'A matching story, tailored individually for Baba and Son.' },
{ title:'A Look You Will Share', note:'Two personal fits, finished with one shared character.' },
{ title:'A Moment Made Yours', note:'Your Main Aur Baba set is ready to move forward.' },
{ title:'More Than Matching', note:'A coordinated order built around two individual fits.' },
{ title:'Your Shared Look Is Complete', note:'Every choice is confirmed for Baba and Son.' },
{ title:'This One Is Special', note:'Two outfits, one fabric story, ready for checkout.' }
]
: state.orderType === 'custom'
? [
{ title:'Made Around You', note:'Your fabric, fit and finishing choices are all in place.' },
{ title:'Your Outfit Is Ready', note:'Everything is confirmed for your order.' },
{ title:'A Look That Feels Personal', note:'Your selections have come together beautifully.' },
{ title:'This One Is Yours', note:'Fabric, fit and finish are ready for checkout.' },
{ title:'Your Choices, Brought Together', note:'A complete look shaped around the details you selected.' },
{ title:'Prepared for You', note:'Your order is set with the fit and finish you chose.' },
{ title:'Your Signature Look', note:'Everything is ready for the next step.' },
{ title:'Your Order Feels Complete', note:'The important choices are confirmed and ready.' },
{ title:'Ready to Become Yours', note:'Your fabric and tailoring choices are now complete.' },
{ title:'Made to Feel Like Yours', note:'Your order is ready to move into checkout.' }
]
: [
{ title:'A Fabric Worth Taking Home', note:'Your chosen fabric is ready for checkout.' },
{ title:'Your Selection Is Ready', note:'A simple final look before checkout.' },
{ title:'A Strong Selection', note:'Your fabric choice is confirmed.' },
{ title:'Your Fabric, Ready', note:'Everything is set for checkout.' },
{ title:'Your Choice Is Confirmed', note:'Your selected fabric is ready to move forward.' },
{ title:'This One Is Yours', note:'Your fabric choice is confirmed for checkout.' },
{ title:'Ready to Take Forward', note:'Your fabric selection is complete.' },
{ title:'The Fabric Is Set', note:'One final look before checkout.' },
{ title:'Your Fabric Selection', note:'Confirmed and ready for checkout.' },
{ title:'A Choice to Keep', note:'Your selected fabric is ready.' }
];
let nextMomentIndex = Math.floor(Math.random() * rewardMoments.length);
if (rewardMoments.length > 1 && nextMomentIndex === state.reviewMomentIndex){
nextMomentIndex = (nextMomentIndex + 1) % rewardMoments.length;
}
state.reviewMomentIndex = nextMomentIndex;
const moment = rewardMoments[nextMomentIndex];
if (awardTitle) awardTitle.textContent = moment.title;
if (awardNote) awardNote.textContent = moment.note;
const reviewHero = $('.sgf-v3__review-hero');
if (reviewHero){
reviewHero.classList.remove('is-rewarded');
window.requestAnimationFrame(() => {
window.requestAnimationFrame(() => reviewHero.classList.add('is-rewarded'));
});
}
const heading = $('[data-review-fabric-heading]');
if (heading){
heading.textContent = count === 1 ? 'Selected Fabric' : `${count} Selected Fabrics`;
}
const productsWrap = $('[data-review-products]');
if (productsWrap){
productsWrap.innerHTML = '';
const reviewFabrics = fabrics;
const deckCount = $('[data-review-deck-count]');
if (deckCount) deckCount.hidden = true;
const openStack = reviewFabrics.length <= 3;
productsWrap.classList.toggle('is-open-stack', openStack);
productsWrap.classList.toggle('is-scroll-stack', !openStack);
productsWrap.dataset.stackCount = String(reviewFabrics.length);
const baseCardHeight = window.innerWidth < 750 ? 50 : 58;
const openStep = reviewFabrics.length === 2
? (window.innerWidth < 750 ? 48 : 54)
: reviewFabrics.length === 3
? (window.innerWidth < 750 ? 34 : 40)
: 0;
if (openStack){
productsWrap.style.height = `${baseCardHeight + (openStep * Math.max(0, reviewFabrics.length - 1))}px`;
} else {
productsWrap.style.height = window.innerWidth < 750 ? '132px' : '148px';
}
reviewFabrics.forEach((fabric, index) => {
const choice = currentFabricChoice();
const variant = variantForFabric(fabric, choice);
const qty = currentFabricQuantity();
const linePrice = Number(variant?.price || 0) * qty;
const image = variant?.image || fabric.image || fabric.fourMeterImage || '';
const colorText = fabric.color ? `${fabric.color} · ` : '';
let cutText =
state.orderType === 'custom' &&
state.forWhom === 'main-baba' &&
mainBabaUsesTwoAdultCuts()
? '4M × 2'
: (variant?.title || choice || '');
cutText = String(cutText)
.replace(/\s*Meters?/i,'M')
.replace(/\s*Metres?/i,'M');
const row = document.createElement('div');
row.className = 'sgf-v3__review-product';
row.style.zIndex = String(reviewFabrics.length - index);
row.classList.toggle('is-top-card', index === 0);
if (openStack){
row.style.top = `${Math.round(index * openStep)}px`;
} else {
row.style.setProperty('--stack-index', String(index));
}
const img = document.createElement('img');
img.className = 'sgf-v3__review-img';
img.alt = '';
if (image){
img.src = image;
img.loading = 'lazy';
img.decoding = 'async';
} else {
img.style.display = 'none';
}
const copy = document.createElement('div');
const title = document.createElement('strong');
title.textContent = fabric.title || `Fabric ${index + 1}`;
const meta = document.createElement('span');
meta.textContent = `${colorText}${cutText} · ${moneyFromCents(linePrice)}`;
copy.appendChild(title);
copy.appendChild(meta);
row.appendChild(img);
row.appendChild(copy);
productsWrap.appendChild(row);
});
}
$('[data-review-order]').textContent =
state.orderType === 'custom' ? 'Signature Stitching' : 'Unstitched';
const forRow = $('[data-review-for-row]');
if (state.orderType === 'custom'){
forRow.style.display = '';
$('[data-review-for]').textContent =
state.forWhom === 'main-baba' ? 'Main Aur Baba' : 'For Myself';
} else {
forRow.style.display = 'none';
}
const styleRow = $('[data-review-style-row]');
if (state.orderType === 'unstitched'){
$('[data-review-fit]').textContent = state.length || '—';
styleRow.style.display = 'none';
} else if (state.forWhom === 'main-baba'){
const babaFitText = state.babaFit === 'custom'
? 'Personal'
: (state.babaSize || 'Standard');
const sonFitText = state.sonFit === 'custom'
? 'Personal'
: (state.sonSize ? `Age ${state.sonSize}` : 'Standard');
$('[data-review-fit]').textContent = `Baba ${babaFitText} · Son ${sonFitText}`;
styleRow.style.display = '';
} else {
$('[data-review-fit]').textContent =
state.fit === 'custom'
? 'Personal Fit'
: (state.size ? `Standard · ${state.size}` : 'Standard');
styleRow.style.display = '';
}
const styleParts = [
state.styles.collar,
state.styles.sleeve,
state.styles.bottom
].filter(Boolean);
$('[data-review-style]').textContent =
styleParts.length ? styleParts.join(' · ') : '—';
const fabricCents = currentFabricPrice();
const stitchingCents = stitchingTotalPrice();
$('[data-price-fabric]').textContent = moneyFromCents(fabricCents);
const stitchingRow = $('[data-price-stitching-row]');
if (state.orderType === 'custom'){
stitchingRow.style.display = '';
$('[data-price-stitching]').textContent = moneyFromCents(stitchingCents);
} else {
stitchingRow.style.display = 'none';
}
$('[data-price-total]').textContent = moneyFromCents(fabricCents + stitchingCents);
}
/* HERO */
startBtn?.addEventListener('click', () => {
clearAttentionTimer();
startBtn.classList.remove('sgf-attention');
root.classList.add('is-building');
setStep(1);
});
updateSelectionSummary();
updateLivePrice();
const startNonCriticalUI = () => {
scheduleAttention(4600);
startHelpPillSequence();
};
if ('requestIdleCallback' in window){
window.requestIdleCallback(startNonCriticalUI, { timeout: 1400 });
} else {
window.setTimeout(startNonCriticalUI, 420);
}
backBtn?.addEventListener('click', () => {
if (state.step === 1){
root.classList.remove('is-building');
root.scrollIntoView({block:'start'});
return;
}
setStep(state.step - 1);
});
/* FABRICS */
function pruneEmptyFabricFilters(){
const cards = $$('[data-sgf-fabric]');
$$('[data-filter]').forEach(btn => {
const filter = String(btn.dataset.filter || '');
if (!filter || filter === 'all') return;
btn.hidden = !cards.some(card => String(card.dataset.filterText || '').includes(filter));
});
}
pruneEmptyFabricFilters();
function fabricStateFromCard(card){
return {
key: `${card.dataset.productId || ''}:${card.dataset.color || ''}:${card.dataset.fourMeterVariantId || ''}`,
productId: card.dataset.productId,
handle: card.dataset.productHandle,
title: card.dataset.title,
color: card.dataset.color || '',
price: Number(card.dataset.price || 0),
image: card.dataset.image,
fourMeterVariantId: card.dataset.fourMeterVariantId || null,
fourMeterPrice: Number(card.dataset.fourMeterPrice || 0),
fourMeterImage: card.dataset.fourMeterImage || card.dataset.image || '',
fourMeterAvailable: card.dataset.fourMeterAvailable === 'true',
fiveMeterVariantId: card.dataset.fiveMeterVariantId || null,
fiveMeterPrice: Number(card.dataset.fiveMeterPrice || 0),
fiveMeterAvailable: card.dataset.fiveMeterAvailable === 'true',
sixMeterVariantId: card.dataset.sixMeterVariantId || null,
sixMeterPrice: Number(card.dataset.sixMeterPrice || 0),
sixMeterImage: card.dataset.sixMeterImage || '',
sixMeterAvailable: card.dataset.sixMeterAvailable === 'true'
};
}
function updateSelectionSummary(){
const count = selectedFabrics().length;
if (selectionSummary){
selectionSummary.classList.toggle('is-visible', count > 0);
}
if (selectionCount){
selectionCount.textContent = `${count} fabric${count === 1 ? '' : 's'} selected`;
}
if (state.step === 1){
setNextButtonText(count > 1
? `Next: Choose Your Order (${count}) →`
: 'Next: Choose Your Order →');
}
}
function selectFabricCard(card){
if (!card || card.dataset.disabled === 'true') return;
const fabric = fabricStateFromCard(card);
const key = fabric.key;
const index = state.fabrics.findIndex(item => item.key === key);
if (index >= 0){
state.fabrics.splice(index, 1);
card.classList.remove('is-selected');
card.setAttribute('aria-pressed','false');
} else {
state.fabrics.push(fabric);
card.classList.add('is-selected');
card.setAttribute('aria-pressed','true');
}
syncPrimaryFabric();
$$('[data-length]').forEach(btn => {
const label = String(btn.dataset.length || '');
btn.hidden = selectedFabrics().length ? !allSelectedHaveChoice(label) : false;
});
if (state.length && !allSelectedHaveChoice(state.length)){
state.length = null;
$$('[data-length]').forEach(btn => btn.classList.remove('is-selected'));
}
updateSelectionSummary();
interactionHappened();
if (guideOpen) guideForCurrentStep(70);
if (selectedFabrics().length){
window.setTimeout(() => premiumAttention(nextBtn), 120);
}
}
$$('[data-sgf-fabric]').forEach(card => {
card.addEventListener('click', () => selectFabricCard(card));
card.addEventListener('keydown', event => {
if (event.key !== 'Enter' && event.key !== ' ') return;
event.preventDefault();
selectFabricCard(card);
});
});
$$('.sgf-v3__filter').forEach(btn => {
btn.addEventListener('click', () => {
$$('.sgf-v3__filter').forEach(x => x.classList.remove('is-active'));
btn.classList.add('is-active');
const filter = btn.dataset.filter;
let visible = 0;
$$('[data-sgf-fabric]').forEach(card => {
const haystack = card.dataset.filterText || '';
const show = filter === 'all' || haystack.includes(filter);
card.style.display = show ? '' : 'none';
if (show) visible++;
});
const empty = $('[data-filter-empty]');
if (empty) empty.style.display = visible ? 'none' : 'block';
});
});
root.addEventListener('input', event => clearValidationError(event.target));
root.addEventListener('change', event => clearValidationError(event.target));
root.addEventListener('click', event => {
  const control = event.target.closest('button,input,select,textarea');
  if (control) clearValidationError(control);
});
/* ORDER TYPE */
$$('[data-order-type]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-order-type]', btn);
state.orderType = btn.dataset.orderType;
if (state.orderType === 'custom'){
customOrderOptions?.classList.add('is-visible');
} else {
customOrderOptions?.classList.remove('is-visible');
state.forWhom = null;
$$('[data-for]').forEach(x => x.classList.remove('is-selected'));
if (babaDescription) babaDescription.hidden = true;
}
updateAdvancePaymentNotice();
interactionHappened();
if (guideOpen) guideForCurrentStep(80);
if (state.orderType === 'custom'){
smartScrollTo(customOrderOptions, { delay:120, align:'nearest' });
window.setTimeout(() => guideTarget('[data-for]'), 300);
} else {
window.setTimeout(() => premiumAttention(nextBtn), 260);
}
});
});
$$('[data-for]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-for]', btn);
state.forWhom = btn.dataset.for;
if (babaDescription){
babaDescription.hidden = state.forWhom !== 'main-baba';
}
updateAdvancePaymentNotice();
interactionHappened();
if (guideOpen) guideForCurrentStep(80);
if (state.forWhom === 'main-baba' && babaDescription && !babaDescription.hidden){
smartScrollTo(babaDescription, { delay:90, align:'nearest' });
}
window.setTimeout(() => premiumAttention(nextBtn), 180);
});
});
/* STEP 3 */
$$('[data-length]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-length]', btn);
state.length = btn.dataset.length;
interactionHappened();
window.setTimeout(() => premiumAttention(nextBtn), 320);
});
});
$$('[data-fit]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-fit]', btn);
state.fit = btn.dataset.fit;
standardSize?.classList.toggle('is-visible', state.fit === 'standard');
customMeasurements?.classList.toggle('is-visible', state.fit === 'custom');
updateAdvancePaymentNotice();
interactionHappened();
if (state.fit === 'standard'){
smartScrollTo(standardSize, { delay:95, align:'nearest' });
window.setTimeout(() => guideTarget('[data-size]'), 280);
} else if (state.fit === 'custom'){
revealPersonalFit('myself', customMeasurements);
}
});
});
$$('[data-size]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-size]', btn);
state.size = btn.dataset.size;
interactionHappened();
scrollToNextVisible('[data-myself-tailoring]', 100, 'nearest');
});
});
$$('[data-measure]').forEach(input => {
input.addEventListener('input', () => {
state.measurements[input.dataset.measure] = input.value.trim();
markSavedProfileEditable('myself');
state.unusualConfirmedSignature = null;
interactionHappened();
});
});
$$('[data-style-group]').forEach(btn => {
btn.addEventListener('click', () => {
const group = btn.dataset.styleGroup;
$$(`[data-style-group="${group}"]`).forEach(x => x.classList.remove('is-selected'));
btn.classList.add('is-selected');
state.styles[group] = btn.dataset.styleValue;
interactionHappened();
const currentGroup = btn.closest('.sgf-v3__style-group');
if (currentGroup){
const allGroups = $$('.sgf-v3__style-group').filter(el => el.offsetParent !== null);
const index = allGroups.indexOf(currentGroup);
const nextGroup = index >= 0 ? allGroups[index + 1] : null;
if (nextGroup) smartScrollTo(nextGroup, { delay:85, align:'nearest' });
}
});
});
$('[data-special-instructions]')?.addEventListener('input', e => {
state.instructions = e.currentTarget.value.trim();
interactionHappened();
});
$$('[data-baba-fit]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-baba-fit]', btn);
state.babaFit = btn.dataset.babaFit;
babaStandard?.classList.toggle('is-visible', state.babaFit === 'standard');
babaCustom?.classList.toggle('is-visible', state.babaFit === 'custom');
updateAdvancePaymentNotice();
interactionHappened();
if (state.babaFit === 'standard'){
smartScrollTo(babaStandard, { delay:90, align:'nearest' });
window.setTimeout(() => guideTarget('[data-baba-size]'), 200);
} else if (state.babaFit === 'custom'){
revealPersonalFit('baba', babaCustom);
}
});
});
$$('[data-son-fit]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-son-fit]', btn);
state.sonFit = btn.dataset.sonFit;
sonStandard?.classList.toggle('is-visible', state.sonFit === 'standard');
sonCustom?.classList.toggle('is-visible', state.sonFit === 'custom');
updateAdvancePaymentNotice();
interactionHappened();
if (state.sonFit === 'standard'){
smartScrollTo(sonStandard, { delay:90, align:'nearest' });
window.setTimeout(() => guideTarget('[data-son-size]'), 200);
} else if (state.sonFit === 'custom'){
revealPersonalFit('son', sonCustom);
}
});
});
$$('[data-baba-measure]').forEach(input => {
input.addEventListener('input', () => {
state.babaMeasurements[input.dataset.babaMeasure] = input.value.trim();
markSavedProfileEditable('baba');
interactionHappened();
});
});
$$('[data-son-measure]').forEach(input => {
input.addEventListener('input', () => {
state.sonMeasurements[input.dataset.sonMeasure] = input.value.trim();
markSavedProfileEditable('son');
interactionHappened();
});
});
$$('[data-baba-size]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-baba-size]', btn);
state.babaSize = btn.dataset.babaSize;
interactionHappened();
scrollToDecisionProfile($('[data-son-profile]'), 95);
});
});
$$('[data-measure-file]').forEach(input => {
input.addEventListener('change', async () => {
const type = input.dataset.measureFile;
const file = input.files && input.files[0] ? input.files[0] : null;
if (!file) return;
const accepted = await acceptMeasurementFile(type, file);
if (!accepted) input.value = '';
});
});
$$('[data-remove-upload]').forEach(btn => {
btn.addEventListener('click', () => {
clearMeasurementFile(btn.dataset.removeUpload);
});
});
$$('[data-son-size]').forEach(btn => {
btn.addEventListener('click', () => {
selectOne('[data-son-size]', btn);
state.sonSize = btn.dataset.sonSize;
interactionHappened();
scrollToNextVisible('[data-main-baba-tailoring]', 100, 'nearest');
});
});
$$('[data-save-profile]').forEach(btn => {
btn.addEventListener('click', () => saveMeasurementsProfile(btn.dataset.saveProfile));
});
$$('[data-load-profile]').forEach(btn => {
btn.addEventListener('click', () => loadMeasurementsProfile(btn.dataset.loadProfile));
});
$$('[data-update-profile]').forEach(btn => {
btn.addEventListener('click', () => {
saveMeasurementsProfile(btn.dataset.updateProfile);
btn.closest('details')?.removeAttribute('open');
});
});
$$('[data-clear-profile]').forEach(btn => {
btn.addEventListener('click', () => clearMeasurementsProfile(btn.dataset.clearProfile));
});
['myself','baba','son'].forEach(type => {
refreshSavedFitUI(type);
updateMeasurementUploadUI(type);
});
/* REVIEW EDIT */
$$('[data-edit-step]').forEach(btn => {
btn.addEventListener('click', () => {
setStep(Number(btn.dataset.editStep));
});
});
/* SIZE CHART */
let lastModalTrigger = null;
function openChartDialog(dialog, trigger){
if (!dialog) return;
lastModalTrigger = trigger || document.activeElement;
if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open','');
dialog.querySelector('[data-size-chart-close],[data-kids-size-chart-close]')?.focus();
}
function closeChartDialog(dialog){
if (!dialog) return;
if (typeof dialog.close === 'function' && dialog.open) dialog.close(); else dialog.removeAttribute('open');
lastModalTrigger?.focus?.();
lastModalTrigger = null;
}
$$('[data-size-chart-open]').forEach(btn => btn.addEventListener('click', () => openChartDialog(sizeChartModal, btn)));
$('[data-size-chart-close]')?.addEventListener('click', () => closeChartDialog(sizeChartModal));
sizeChartModal?.addEventListener('click', e => { if (e.target === sizeChartModal) closeChartDialog(sizeChartModal); });
$$('[data-kids-size-chart-open]').forEach(btn => btn.addEventListener('click', () => openChartDialog(kidsSizeChartModal, btn)));
$('[data-kids-size-chart-close]')?.addEventListener('click', () => closeChartDialog(kidsSizeChartModal));
kidsSizeChartModal?.addEventListener('click', e => { if (e.target === kidsSizeChartModal) closeChartDialog(kidsSizeChartModal); });
function cleanProperties(obj){
const cleaned = {};
Object.entries(obj).forEach(([key, value]) => {
if (value === null || typeof value === 'undefined') return;
const stringValue = String(value).trim();
if (!stringValue) return;
cleaned[key] = stringValue;
});
return cleaned;
}
function selfStitchingProperties(reference, fabric, setNumber, setCount){
const props = {
'SGF Reference': reference,
'Stitching House': 'For Myself',
'Fabric Set': `${setNumber} of ${setCount}`,
'Fabric': fabric?.title || '',
'Color': fabric?.color || '',
'Fabric Length': '4 Meters',
'Fit Method': state.fit === 'custom' ? 'Custom Measurements' : 'Standard Size',
'Standard Size': state.fit === 'standard' ? state.size : '',
'_Measurement Source': state.fit === 'custom'
? (hasMeasurementFile('myself') ? 'Uploaded Tailor Slip / Size Chart' : 'Entered Measurements')
: '',
'_Measurement File Reference': state.fit === 'custom' && hasMeasurementFile('myself') && setNumber > 1
? 'Attached to Fabric Set 1 under the same SGF Reference'
: '',
'Neck Style': state.styles.collar || '',
'Sleeve Finish': state.styles.sleeve || '',
'Bottom Type': state.styles.bottom || '',
'Additional Notes': state.instructions || ''
};
if (state.fit === 'custom'){
Object.entries(state.measurements).forEach(([key, value]) => {
if (value) props[key] = `${value} in`;
});
}
return cleanProperties(props);
}
function mainBabaProperties(reference, profile, fabric, setNumber, setCount){
const isBaba = profile === 'Baba';
const fitMethod = isBaba ? state.babaFit : state.sonFit;
const measurements = isBaba ? state.babaMeasurements : state.sonMeasurements;
const props = {
'SGF Reference': reference,
'Stitching House': 'Main Aur Baba',
'Fabric Set': `${setNumber} of ${setCount}`,
'Profile': profile,
'Fabric': fabric?.title || '',
'Color': fabric?.color || '',
'Fabric Length': mainBabaUsesTwoAdultCuts()
? '4 Meters Each — Baba + Son'
: '6 Meters — Shared Fabric',
'Fabric Rule': mainBabaUsesTwoAdultCuts()
? 'Two full 4M cuts because Son uses Personal Measurements'
: 'Shared 6M cut because Son uses Standard / Age Size',
'Fit Method': fitMethod === 'custom' ? 'Custom Measurements' : 'Standard Size',
'Size': fitMethod === 'standard'
? (isBaba ? state.babaSize : state.sonSize)
: '',
'_Measurement Source': fitMethod === 'custom'
? (hasMeasurementFile(isBaba ? 'baba' : 'son')
? 'Uploaded Tailor Slip / Size Chart'
: 'Entered Measurements')
: '',
'_Measurement File Reference': fitMethod === 'custom'
&& hasMeasurementFile(isBaba ? 'baba' : 'son')
&& setNumber > 1
? 'Attached to Fabric Set 1 under the same SGF Reference'
: '',
'Neck Style': state.styles.collar || '',
'Sleeve Finish': state.styles.sleeve || '',
'Bottom Type': state.styles.bottom || ''
};
if (fitMethod === 'custom'){
Object.entries(measurements).forEach(([key, value]) => {
if (value) props[key] = `${value} in`;
});
}
return cleanProperties(props);
}
function fabricProperties(reference, fabricVariant, fabric, setNumber, setCount){
return cleanProperties({
'SGF Reference': reference,
'Fabric Set': `${setNumber} of ${setCount}`,
'Fabric': fabric?.title || '',
'Color': fabric?.color || '',
'Order Type': state.orderType === 'custom' ? 'SGF Signature Stitching' : 'Unstitched Only',
'For': state.orderType === 'custom'
? (state.forWhom === 'main-baba' ? 'Main Aur Baba' : 'For Myself')
: '',
'Fabric Selection': fabricVariant?.title || state.length || '',
'Fabric Quantity Rule': state.forWhom === 'main-baba'
? (mainBabaUsesTwoAdultCuts() ? '4 Meters × 2' : '6 Meters × 1')
: ''
});
}
function cartRootUrl(){
return (
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '/'
);
}
async function parseCartError(response, fallback){
try{
const payload = await response.json();
return payload.description || payload.message || fallback;
}catch(e){
return fallback;
}
}
async function addJsonCartItems(rootUrl, items){
if (!items.length) return [];
const response = await fetch(`${rootUrl}cart/add.js`, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'Accept': 'application/json'
},
body: JSON.stringify({ items })
});
if (!response.ok){
throw new Error(
await parseCartError(
response,
'We could not add this Stitching House order to your cart.'
)
);
}
const payload = await response.json();
return Array.isArray(payload.items) ? payload.items : [payload];
}
async function addCartLineWithMeasurementFile(rootUrl, request){
const formData = new FormData();
formData.append('id', String(request.id));
formData.append('quantity', String(request.quantity || 1));
Object.entries(request.properties || {}).forEach(([key, value]) => {
if (value === null || typeof value === 'undefined') return;
const stringValue = String(value).trim();
if (!stringValue) return;
formData.append(`properties[${key}]`, stringValue);
});
formData.append(
'properties[_Tailor Slip / Size Chart]',
request.file,
request.file.name || 'measurement-slip.jpg'
);
const response = await fetch(`${rootUrl}cart/add.js`, {
method: 'POST',
headers: { 'Accept': 'application/json' },
body: formData
});
if (!response.ok){
throw new Error(
await parseCartError(
response,
'We could not upload the tailor slip / size chart.'
)
);
}
const payload = await response.json();
return Array.isArray(payload.items) ? payload.items : [payload];
}
async function rollbackConfiguration(rootUrl, reference, knownKeys = []){
const keys = new Set((knownKeys || []).filter(Boolean));
try{
const cartResponse = await fetch(`${rootUrl}cart.js`, { headers:{ 'Accept':'application/json' } });
if (cartResponse.ok){
const cart = await cartResponse.json();
(cart.items || []).forEach(item => {
if (item?.properties?.['SGF Reference'] === reference && item.key) keys.add(item.key);
});
}
}catch(error){ console.warn('SGF rollback cart inspection failed:', error); }
if (!keys.size) return true;
try{
const updates = {};
keys.forEach(key => { updates[key] = 0; });
const response = await fetch(`${rootUrl}cart/update.js`, {
method:'POST',
headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
body:JSON.stringify({ updates })
});
if (!response.ok) throw new Error('Cart cleanup failed.');
return true;
}catch(error){
console.error('SGF cart rollback failed:', error);
return false;
}
}
async function addConfigurationToCart(){
const fabrics = selectedFabrics();
if (!fabrics.length){
throw new Error('Please select at least one fabric.');
}
const choice = currentFabricChoice();
const quantity = currentFabricQuantity();
const reference = `SGF-${Date.now().toString(36).toUpperCase()}`;
const batchItems = [];
const fileRequests = [];
fabrics.forEach((fabric, index) => {
const fabricVariant = variantForFabric(fabric, choice);
if (!fabricVariant || !fabricVariant.id){
throw new Error(
state.orderType === 'custom' && state.forWhom === 'main-baba'
? (mainBabaUsesTwoAdultCuts()
? `${fabric.title} does not have the required 4 Meter variant.`
: `${fabric.title} does not have the required 6 Meter variant.`)
: state.orderType === 'custom'
? `${fabric.title} does not have the required 4 Meter variant.`
: `${fabric.title} does not have the selected ${state.length || 'length'} variant.`
);
}
if (fabricVariant.available === false){
throw new Error(`${fabric.title} — ${fabricVariant.title} is currently unavailable.`);
}
batchItems.push({
id: Number(fabricVariant.id),
quantity,
properties: fabricProperties(reference, fabricVariant, fabric, index + 1, fabrics.length)
});
});
if (state.orderType === 'custom'){
const serviceVariantId = Number(root.dataset.stitchingServiceVariantId || 0);
const serviceAvailable = root.dataset.stitchingServiceAvailable === 'true';
if (!serviceVariantId){
throw new Error('The SGF stitching service product has not been selected in the Theme Editor.');
}
if (!serviceAvailable){
throw new Error('The SGF stitching service is currently unavailable.');
}
fabrics.forEach((fabric, index) => {
const setNumber = index + 1;
if (state.forWhom === 'main-baba'){
const babaProps = mainBabaProperties(reference, 'Baba', fabric, setNumber, fabrics.length);
const sonProps = mainBabaProperties(reference, 'Son', fabric, setNumber, fabrics.length);
if (state.babaFit === 'custom' && hasMeasurementFile('baba') && index === 0){
fileRequests.push({
id: serviceVariantId,
quantity: 1,
properties: babaProps,
file: measurementFile('baba')
});
} else {
batchItems.push({
id: serviceVariantId,
quantity: 1,
properties: babaProps
});
}
if (state.sonFit === 'custom' && hasMeasurementFile('son') && index === 0){
fileRequests.push({
id: serviceVariantId,
quantity: 1,
properties: sonProps,
file: measurementFile('son')
});
} else {
batchItems.push({
id: serviceVariantId,
quantity: 1,
properties: sonProps
});
}
} else {
const selfProps = selfStitchingProperties(reference, fabric, setNumber, fabrics.length);
if (state.fit === 'custom' && hasMeasurementFile('myself') && index === 0){
fileRequests.push({
id: serviceVariantId,
quantity: 1,
properties: selfProps,
file: measurementFile('myself')
});
} else {
batchItems.push({
id: serviceVariantId,
quantity: 1,
properties: selfProps
});
}
}
});
}
const rootUrl = cartRootUrl();
const addedKeys = [];
try{
for (const request of fileRequests){
const added = await addCartLineWithMeasurementFile(rootUrl, request);
added.forEach(item => {
if (item && item.key) addedKeys.push(item.key);
});
}
const batchAdded = await addJsonCartItems(rootUrl, batchItems);
batchAdded.forEach(item => {
if (item && item.key) addedKeys.push(item.key);
});
}catch(error){
const rollbackOk = await rollbackConfiguration(rootUrl, reference, addedKeys);
if (!rollbackOk){
throw new Error(`${error.message || 'Checkout preparation failed.'} Please review your cart before trying again.`);
}
throw error;
}
return true;
}
function checkoutUrl(){
const routeRoot =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '/';
return new URL(`${routeRoot}checkout`, window.location.origin).href;
}
function cartCheckoutFallbackUrl(){
const routeRoot =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '/';
return new URL(`${routeRoot}cart?checkout=1`, window.location.origin).href;
}
async function proceedToCheckout(){
const previousText = getNextButtonText();
const isThemeEditor = Boolean(window.Shopify && window.Shopify.designMode);
let editorCheckoutWindow = null;
if (isThemeEditor){
editorCheckoutWindow = window.open('about:blank', '_blank');
}
nextBtn.disabled = true;
setNextButtonText('Preparing Checkout…');
try{
await addConfigurationToCart();
const primaryCheckout = checkoutUrl();
if (isThemeEditor){
if (editorCheckoutWindow && !editorCheckoutWindow.closed){
editorCheckoutWindow.location.replace(primaryCheckout);
nextBtn.disabled = false;
setNextButtonText(previousText);
return;
}
showMessage('The cart is ready. Shopify Theme Editor blocked the checkout tab — open this page through Preview / View store to test checkout.');
nextBtn.disabled = false;
setNextButtonText(previousText);
return;
}
window.location.replace(primaryCheckout);
window.setTimeout(() => {
if (document.visibilityState === 'visible'){
window.location.replace(cartCheckoutFallbackUrl());
}
}, 1200);
}catch(error){
if (editorCheckoutWindow && !editorCheckoutWindow.closed){
editorCheckoutWindow.close();
}
console.error('SGF Stitching House checkout error:', error);
showMessage(error.message || 'We could not prepare your checkout. Please try again.');
nextBtn.disabled = false;
setNextButtonText(previousText);
scheduleAttention(5200);
}
}
/* NEXT */
nextBtn?.addEventListener('click', () => {
clearAttentionTimer();
nextBtn.classList.remove('sgf-attention');
if (state.step === 1){
if (!state.fabrics.length){
showMessage('Please select at least one fabric before continuing.');
guideTarget('[data-sgf-fabric]');
return;
}
setStep(2);
return;
}
if (state.step === 2){
if (!state.orderType){
showMessage('Please choose Unstitched Only or SGF Signature Stitching.');
guideTarget('[data-order-type]');
return;
}
if (state.orderType === 'custom' && !state.forWhom){
showMessage('Please choose For Myself or Main Aur Baba.');
guideTarget('[data-for]');
return;
}
if (state.orderType === 'custom' && (state.forWhom === 'main-baba' || state.forWhom === 'myself')){
if (!allSelectedHaveChoice('4 Meters')){
showMessage('Every selected fabric needs an available 4 Meter variant for SGF Signature Stitching.');
return;
}
}
setStep(3);
return;
}
if (state.step === 3){
if (!validateStep3()) return;
setStep(4);
return;
}
if (state.step === 4){
proceedToCheckout();
}
});
root._sgfCleanup = () => {
[guideTimer,helpIdleTimer,helpCycleTimer,helpCollapseTimer,attentionTimer,attentionCleanupTimer].forEach(timer => timer && clearTimeout(timer));
if (livePriceFrame) cancelAnimationFrame(livePriceFrame);
Object.keys(measurementPreviewUrls).forEach(type => {
if (measurementPreviewUrls[type]){ URL.revokeObjectURL(measurementPreviewUrls[type]); measurementPreviewUrls[type] = null; }
});
delete root.dataset.sgfV3Ready;
};
}
function initAllSGFStitchingHouses(scope = document){
const roots = [];
if (scope?.matches?.('[data-sgf-stitching-house]')) roots.push(scope);
scope?.querySelectorAll?.('[data-sgf-stitching-house]').forEach(root => roots.push(root));
roots.forEach(initSGFStitchingHouse);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAllSGFStitchingHouses(), { once:true });
else initAllSGFStitchingHouses();
document.addEventListener('shopify:section:load', event => initAllSGFStitchingHouses(event.target));
document.addEventListener('shopify:section:unload', event => {
const roots = [];
if (event.target?.matches?.('[data-sgf-stitching-house]')) roots.push(event.target);
event.target?.querySelectorAll?.('[data-sgf-stitching-house]').forEach(root => roots.push(root));
roots.forEach(root => root._sgfCleanup?.());
});

  } catch(e) { console.error(e); }
})();
})();
